import createListViewContext, { type FilterValues } from 'global/helpers/createListViewContext'
import { VehicleType } from 'screens/VehicleManager/VehicleManager.types'

export interface VehiclesFilterValues extends FilterValues {
  keywords: string[]
  vehicleTypes: VehicleType[]
}

const defaultFilters: VehiclesFilterValues = {
  keywords: [],
  vehicleTypes: Object.values(VehicleType),
}

const { ListViewProvider, useListView } = createListViewContext(defaultFilters)

export { ListViewProvider as VehiclesViewProvider, useListView as useVehiclesView }
